import { put, takeEvery } from 'redux-saga/effects';

import { RoleAction } from '../actions';
import { RoleConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [RoleConstant.CREATE_ROLE_SUCCESS, RoleConstant.EDIT_ROLE_SUCCESS],
    createOrEditRoleSuccess,
  );
  yield takeEvery(RoleConstant.DELETE_ROLE_SUCCESS, deleteRoleSuccess);
  yield takeEvery(RoleConstant.GET_ROLES_SUCCESS, getRolesSuccess);
  yield takeEvery(RoleConstant.GET_ROLE_SUCCESS, getRoleSuccess);
}

function* createOrEditRoleSuccess() {
  yield put(RoleAction.setRole({}));
}

function* deleteRoleSuccess() {
  yield put(RoleAction.getRoles());
}

function* getRolesSuccess(action) {
  yield put(RoleAction.setRoles(action?.payload));
}

function* getRoleSuccess(action) {
  yield put(RoleAction.setRole(action?.payload));
}
